import { motion } from "framer-motion";

const items = [
  {
    n: "01",
    title: "Mission",
    body: "To innovate and deliver advanced, easy-to-use therapeutic solutions that address critical medical emergencies - empowering healthcare providers and civilians alike with technology that enhances rapid response in life-threatening situations.",
  },
  {
    n: "02",
    title: "Vision",
    body: "To be at the forefront of transforming emergency medical care through evolving technologies - creating a world where advanced, reliable emergency interventions are available to all, minimising the impact of critical medical situations.",
  },
  {
    n: "03",
    title: "What We Do",
    body: "We pioneer science-driven solutions at the intersection of biotechnology, emergency medicine, and software innovation - transforming urgent healthcare challenges into accessible, life-saving technologies and platforms.",
  },
];

export const Company = () => {
  return (
    <section
      id="company"
      data-testid="company-section"
      className="relative section-pad bg-[#0A0A0C]"
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(230,0,0,0.08),transparent_60%)] pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-2 h-2 rounded-full bg-[#E60000]" />
          <span className="eyebrow">COMPANY · 001</span>
        </div>

        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-7 font-display text-4xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tighter font-medium text-white"
          >
            Unyielding
            <br />
            in every <span className="italic font-light">emergency.</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="lg:col-span-5 text-base sm:text-lg text-blude-textDim self-end leading-relaxed text-left"
          >
            Blude Life Science and Tech pioneers breakthrough therapeutic
            solutions for critical emergencies - driven by rigorous research and
            real-time advancements.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {items.map((it, i) => (
            <motion.div
              key={it.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
              className="card-tile p-7 sm:p-8 min-h-[320px] group"
              data-testid={`company-card-${it.n}`}
            >
              <div className="absolute -right-6 -top-10 font-display text-[180px] leading-none font-bold text-white/[0.03] group-hover:text-[#E60000]/[0.08] transition-colors duration-700 select-none">
                {it.n}
              </div>
              <div className="relative">
                <div className="eyebrow-dim mb-4">PILLAR · {it.n}</div>
                <h3 className="font-display text-3xl text-white mb-4 tracking-tight">
                  {it.title}
                </h3>
                <p className="text-[15px] text-blude-textDim leading-relaxed text-left">
                  {it.body}
                </p>
              </div>
              <div className="relative mt-8 h-px bg-gradient-to-r from-[#E60000]/60 to-transparent" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
